export enum SearchType {
    TERMINAL_INFO_WITH_USERS, TERMINAL_LIST, USER_INFO
}